import React, { FunctionComponent, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import theme, { ThemeProvider } from 'shamrock-clover-ui/dist/clover/Theme/Theme';
import Login from '../../components/login/Login';
import { I18nextProvider } from 'react-i18next';
import i18nFromShell from '../../i18n';
import { Provider, useDispatch } from 'react-redux';
import store from '../../redux/configureStore';
import { featureService } from '../../services/feature.service';
import { setFeatures } from '../../redux/actions/appActions';
import { Auth0Provider } from '@auth0/auth0-react';

const Config = require('Config');

const AuthLanding: FunctionComponent = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    (async () => {
      const features = await featureService.getFeatures();
      dispatch(setFeatures(features));
    })();
  }, []);
  return <Login />;
};

const router = createBrowserRouter([
  {
    path: '/auth',
    element: <AuthLanding />,
  },
]);

const main = () => {
  const root = createRoot(document.getElementById('app'));
  root.render(
    <Auth0Provider
      domain={Config.auth0CustomDomain}
      clientId={Config.auth0ClientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: `https://${Config.auth0Domain}/api/v2/`,
        scope: 'openid profile email offline_access',
      }}>
      <Provider store={store}>
        <I18nextProvider i18n={i18nFromShell}>
          <ThemeProvider theme={theme}>
            <RouterProvider router={router} />
          </ThemeProvider>
        </I18nextProvider>
      </Provider>,
    </Auth0Provider>,
  );
};

main();
